<template>
  <b-checkbox
    :value="value"
    :native-value="{ id: option.id }"
    type="is-green"
    :class="{ 'is-checked': isChecked() }"
    @input="change"
  >
    <div ref="main">
      <span class="option-title">
        <span>
          {{ option.name }}
        </span>
        <template v-for="(icon, index2) in option.images">
          <b-icon v-if="icon" :key="index2" :icon="icon" />
        </template>
        <span v-if="option.recommended" class="option-recommended">
          {{ $t('fields.recommended') }}
        </span>
      </span>
    </div>
  </b-checkbox>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    option: {
      type: Object,
      default: null
    },
    addons: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    change (val) {
      if (this.addons.length) {
        val.some((item, index) => {
          const find = this.addons.find(addon => addon.id === item.id)
          return find && find.proGuard && find.id !== this.option.id ? val.splice(index, 1) : false
        })
      }
      this.$emit('input', val)
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    isChecked () {
      return this.value.find(option => option.id === this.option.id)
    },
    openModal () {
      this.$emit('modal', this.option)
    }
  }
}
</script>
